// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"Gallery_pageContent__cDSDB","videoGroup":"Gallery_videoGroup__3C3bN","videoContainer":"Gallery_videoContainer__hVb83","singleVideo":"Gallery_singleVideo__1Nq_v"};